import { FocusedFieldState } from './types';

export const helpName = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.name || isInvalid
    ? 'Name must be at least one character long and cannot be longer then 60 characters!'
    : null;
};

export const helpOrganization = (
  state: FocusedFieldState,
  isInvalid: boolean
) => {
  return state.organization || isInvalid
    ? 'Must select at least one organization'
    : null;
};

export const helpUsername = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.username || isInvalid
    ? 'Username must be at least one character long'
    : null;
};

export const helpFormat = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.format || isInvalid ? 'Format is required!' : null;
};

export const helpSelectedAuthType = (
  state: FocusedFieldState,
  isInvalid: boolean
) => {
  return state.selectedAuthType || isInvalid ? 'Auth Type is required' : null;
};

export const helpPassword = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.password || isInvalid
    ? 'Password must be at least one character long'
    : null;
};

export const helpPrivateKeyPassword = (
  state: FocusedFieldState,
  isInvalid: boolean
) => {
  return state.privateKeyPassword || isInvalid
    ? 'Password must be at least one character long. Password is needed because private key is encrypted.'
    : null;
};

export const helpLocation = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.location || isInvalid
    ? 'Location must use https:// protocol and url must be valid'
    : null;
};

export const helpAuthURL = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.authEndpoint || isInvalid
    ? 'Location must use https:// protocol and domain name must be at least four characters long'
    : null;
};

export const helpRedirectURI = (
  state: FocusedFieldState,
  isInvalid: boolean
) => {
  return state.redirectURI || isInvalid
    ? 'Redirect URI must use https:// protocol and domain name must be at least four characters long'
    : null;
};

export const helpKey = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.key || isInvalid
    ? 'Key must be at least 32 character long'
    : null;
};

export const helpCode = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.code || isInvalid
    ? 'Code must be at least one character long'
    : null;
};

export const helpPrivateKey = (
  state: FocusedFieldState,
  isInvalid: boolean
) => {
  return state.privateKey || isInvalid
    ? 'Private key must be at least one character long'
    : null;
};

export const helpGrantType = (state: FocusedFieldState, isInvalid: boolean) => {
  return state.grantType || isInvalid
    ? 'Grant type is required for OAuth 2.0'
    : null;
};

export const helpAllowIP = (_state: FocusedFieldState, isInvalid: boolean) => {
  return isInvalid ? 'IP is invalid' : null;
};
